import { AppShellProps } from 'AppShell/types';

export const setCustomFeatureToggles = (props: AppShellProps): AppShellProps => ({
    ...props,
    featureToggles: { ...props.featureToggles },
});
